

export const intro = {
	init: (bool) =>{

		if(bool){
			let introduction = document.querySelector('#video-home');

			if(introduction){
				if(!introduction.attributes.loop){
					// console.log("introduction pas loop", introduction)
					introduction.onended = function(){
						// console.log("fin de la vidéo");
						introduction.src = ''
						return;
					}
				}
			}else{
				// console.log("introduction loop", introduction)
				return;
			}
		}
	}
}